window.addEventListener("load", function () {
  const navDropdownItems = document.querySelectorAll(".nav-dropdown__item.has-mega-menu");
  const megaMenus = document.querySelectorAll(".mega-menu");

  function showFirstMenu(megaMenu) {
    const firstTitleItem = megaMenu.querySelector(".mega-menu__title-item");
    const firstImageGrid = megaMenu.querySelector(".mega-menu__images");

    if (firstTitleItem && firstImageGrid) {
      hideAllMenus(megaMenu);

      firstTitleItem.classList.add("active", "hover-effect");
      firstImageGrid.style.display = "block";
      firstImageGrid.classList.add("active");
    }
  }

  function hideAllMenus(megaMenu) {
    const titleItems = megaMenu.querySelectorAll(".mega-menu__title-item");
    const imageGrids = megaMenu.querySelectorAll(".mega-menu__images");

    titleItems.forEach((item) => item.classList.remove("active", "hover-effect"));
    imageGrids.forEach((grid) => {
      grid.style.display = "none";
      grid.classList.remove("active");
    });
  }

  navDropdownItems.forEach((dropdownItem) => {
    dropdownItem.addEventListener("mouseenter", () => {
      megaMenus.forEach((menu) => (menu.style.display = "none"));

      const currentMegaMenu = dropdownItem.querySelector(".mega-menu");
      if (currentMegaMenu) {
        currentMegaMenu.style.display = "block";
        showFirstMenu(currentMegaMenu);
      }
    });

    dropdownItem.addEventListener("mouseleave", () => {
      const currentMegaMenu = dropdownItem.querySelector(".mega-menu");
      if (currentMegaMenu) {
        currentMegaMenu.style.display = "none";
      }
    });
  });

  megaMenus.forEach((megaMenu) => {
    const titleItems = megaMenu.querySelectorAll(".mega-menu__title-item");

    titleItems.forEach((titleItem) => {
      titleItem.addEventListener("mouseenter", () => {
        hideAllMenus(megaMenu);

        const menuId = titleItem.getAttribute("data-menu-id");
        const correspondingGrid = megaMenu.querySelector(`#${menuId}`);

        if (correspondingGrid) {
          titleItem.classList.add("active", "hover-effect");
          correspondingGrid.style.display = "block";
          correspondingGrid.classList.add("active");
        }
      });
    });
  });
});
